import { render, staticRenderFns } from "./Boagt.vue?vue&type=template&id=6b850369&"
import script from "./Boagt.vue?vue&type=script&lang=js&"
export * from "./Boagt.vue?vue&type=script&lang=js&"
import style0 from "./Boagt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports